import React, { useState } from 'react'
import {BrowserRouter, Routes, Route, useLocation, useNavigate} from 'react-router-dom'
import { Project} from './App'
import * as mui from '@mui/material'
import * as Icons from '@mui/icons-material'
import {Home, Projects, Blogs, Post} from './views'
import { IconButton } from './components/mui'
import NavModel from './model/NavModel'
import { Contact } from './components/Home'
import SEO from './components/SEO'


const Button = mui.styled(mui.Button)(({ theme }) => ({
  color: theme.palette.getContrastText(mui.colors.purple[500]),
  backgroundColor: "#202020",
  marginLeft: '2%',
  marginRight: '2%',
fontFamily:"hussor-bold",

  '&:hover': {
    backgroundColor: "#202020",
    borderBottom:'2px solid whitesmoke'
  },
  '&:focus':{
      border: 'none',
      boxShadow: "none",
      outline: "none"
  },
}));

function RouteConfig() {
  const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Who is Sathish Kumar?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sathish Kumar is a Full Stack and Android Developer specializing in scalable applications, with expertise in Java, React, Node.js, and Android OpenGL rendering."
      }
    },
    {
      "@type": "Question",
      "name": "What services does Sathish Kumar provide?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I build Android applications, React web dashboards, and full stack solutions with Node.js, MongoDB, Firebase, and cloud integrations. In Otherhand, business promotional sites like product landing page and company landing page or portfolios."
      }
    },
    {
      "@type": "Question",
      "name": "How can I hire Sathish Kumar?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can reach me via email at sathishweb27@gmail.com or through LinkedIn at https://www.linkedin.com/in/sathishwebdev/"
      }
    }
  ]
}
  return <BrowserRouter>
  <div className="d-none d-md-block" >
    <NavBar />
  </div>
  <div className="d-block d-md-none" >
    <CollapesNav/>
  </div>
    <Routes>
        <Route exact path='/' element={<Home />} />
        <Route exact path='projects' element={<Projects />} />
        <Route exact path='project/:ProName' element={<Project />} />
        <Route exact path='blogs' element={<Blogs />} />
        <Route exact path='blog/post/:postId/:postName' element={<Post />} />
        <Route exact path='contact' element={<div className='full-con' >
          <SEO title = "Contact - Sathish kumar S | Developer | Sathishwebdev"
          schema={faqSchema}
          />
          <Contact /></div>} />

        <Route path='*' element={<div className='App'>
            <div className="full-con" >
                <h1 style={{
                    fontSize:"50px"
                }} >404</h1>
                <img src='./mearn.png' alt="relax" width="100%" style={{maxWidth:'500px'}} />
            </div>
        </div>} />
    </Routes>
  </BrowserRouter>;
}

export default RouteConfig;


const NavBar = () =>{
  const location = useLocation()
  const navigate = useNavigate()


  return       <div
      className='nav'
  >
      { location.pathname === '/' ? <Button
       href="/#home"
      >
       Home
       </Button> : <Button
       
       onClick={()=>{
       navigate(-1)
       }}
    
       >
     <Icons.ChevronLeftRounded/>  Back
       </Button> }
    
       {location.pathname === '/' || location.pathname === '/projects'  ? '' : <Button
     onClick={()=>{
         navigate('./')
     }}
    >
         Home
     </Button>
       }
        <Button
        href="/#about"
       >
       About
       </Button>
       <Button
        href="/#skill"
       >
       Skills
       </Button>
      <Button
        href='/#projects'
       >
       Projects
       </Button>
      <Button
        href="/#contact"
       >
       Contact
       </Button>

       <Button
       style={{
         backgroundColor:'#D4AC3D',
         color:'black',
         fontFamily:'hussor-bold'
       }}
       href='/contact'
       >
        <Icons.Work /> Hire Me
       </Button> 
  <mui.Button
  sx={{
    border:"2px solid white",
    backgroundColor:"transparent",
    color:"white"
  }}
  onClick={()=>{
    window.open("https://drive.google.com/file/d/1F09U5KGvii9vkK1EPBwCcltKnz8rCUX3/view?usp=sharing", "_blank")}}
  >
   <Icons.FileDownload/> Resume
  </mui.Button>

  <Button href="https://www.buymeacoffee.com/sathishkumar"><img src="https://img.buymeacoffee.com/button-api/?text=Buy me a coffee&emoji=&slug=sathishkumar&button_colour=d4ac3d&font_colour=000000&font_family=Cookie&outline_colour=000000&coffee_colour=FFDD00" alt="Buy Me A Coffee" /></Button>    
  </div>
   
}

const CollapesNav = () =>{
  
  const location = useLocation()

  const navigate = useNavigate()

  const [navStatus, setNavStatus] = useState(false)

  const CloseMenu = () =>{
    document.getElementById('c-nav').style.transform = 'translateY(-100vh)'
    setNavStatus(false)
  }

  const OpenMenu = () =>{
    document.getElementById('c-nav').style.transform = 'translateY(0vh)'
    setNavStatus(true)
  }

  return <div className='row justify-content-between mx-2'>
  <div className='nav-btn' >
    <IconButton
      onClick={!navStatus ? OpenMenu : CloseMenu}
    >
      {!navStatus ? <Icons.Menu fontSize= "large" sx={{color:location.pathname === '/' ? "unset" : "gray"}}/> :<Icons.Close sx={{color:'whitesmoke'}} fontSize='large' />}
    </IconButton>

    <div style={{
         marginLeft:"auto",
         marginRight:"10px",
       }}>
      { location.pathname === '/' ?'' : <IconButton
      
         onClick={()=>{
         navigate(-1)
         }}
      
         >
       <Icons.ChevronLeftRounded sx={{
         color:"gray",
         fontSize:"30px"
       }} />
         </IconButton> }
    </div>
  
    <Button
       style={{
         backgroundColor:'#D4AC3D',
         color:'black',
         fontFamily:'hussor-bold'
       }}
       href='/contact'
       >
        <Icons.Work /> Hire Me
       </Button> 
  <Button
  onClick={()=>{
    window.open("https://drive.google.com/file/d/1F09U5KGvii9vkK1EPBwCcltKnz8rCUX3/view?usp=sharing", "_blank")}}
  >
   <Icons.FileDownload/> Resume
  </Button>

  

  </div>
    <div
    className='collopse-nav' id="c-nav"
    >
   {NavModel.map(({name,link}, id)=>(
     <Button
     key={id}
     sx={{
       margin:'5%'
     }}
     onClick={CloseMenu}
      href={link}
     >
      {name}
      </Button>
   )) }

   <Button href="https://www.buymeacoffee.com/sathishkumar"><img src="https://img.buymeacoffee.com/button-api/?text=Buy me a coffee&emoji=&slug=sathishkumar&button_colour=d4ac3d&font_colour=000000&font_family=Cookie&outline_colour=000000&coffee_colour=FFDD00" alt="Buy Me A Coffee" /></Button>    
    </div>
  </div>

}